import UserService from '@/services/user';

const initialState = () => {
  return {
    loading: false,
    error: null,
    profile: null,
  };
};

export default {
  namespaced: true,
  state: initialState(),
  getters: {
    profile: (state) => state.profile,
    name: (state) => (state.profile ? state.profile.display_name : ''),
    avatar: (state) => (state.profile && state.profile.avatar ? state.profile.avatar : ''),
    profile_bg: (state) => (state.profile && state.profile.profile_bg ? state.profile.profile_bg : ''),
    job_title: (state) => (state.profile ? state.profile.co_role : ''),
    company: (state) => (state.profile ? state.profile.company : ''),
    username: (state) => (state.profile ? state.profile.username : ''),
  },
  mutations: {
    SET_LOADING: (state, payload) => {
      state.loading = payload;
    },
    SET_ERROR: (state, payload) => {
      state.error = payload;
    },
    SET_PROFILE: (state, payload) => {
      state.profile = payload;
    },
    RESET(state) {
      const newState = initialState();
      Object.keys(newState).forEach((key) => {
        state[key] = newState[key];
      });
    },
  },
  actions: {
    async getProfile(context) {
      if (context.state.profile) {
        return;
      }

      context.commit('SET_ERROR', null);
      context.commit('SET_LOADING', true);
      UserService.getProfile()
        .then((response) => {
          context.commit('SET_PROFILE', response.data);
          context.commit('SET_LOADING', false);
        })
        .catch((error) => {
          console.log(error);
          context.commit('SET_ERROR', error.message);
          context.commit('SET_LOADING', false);
        });
    },
    async updateProfile(context, payload) {
      context.commit('SET_ERROR', null);
      context.commit('SET_LOADING', true);
      return UserService.updateProfile(payload)
        .then((response) => {
          context.commit('SET_PROFILE', response.data);
          context.commit('SET_LOADING', false);

          return response.data;
        })
        .catch((error) => {
          console.log(error);
          context.commit('SET_ERROR', error.message);
          context.commit('SET_LOADING', false);
        });
    },
    reset({ commit }) {
      commit('RESET');
    },
  },
};
